<template>
  <div>
    <header class="terms-header">
      <h2 class="terms-title">개인정보 처리방침</h2>
    </header>
    <div class="terms-container">
      <p>핀브릿지 주식회사 (이하 "회사"라 함) 는 고객의 개인정보를 가장 소중한 가치로 여기고 있습니다. 이에 회사는 「신용정보의 이용 및 보호에 관한 법률」, 「개인정보 보호법」, 「통신비밀보호법」 등
        관련 법령상의 개인정보보호 규정을 철저히 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하겠습니다.</p>
      <p>&nbsp;</p>
      <p><strong>제1조 (개인정보의 수집)</strong></p>
      <p>① 본 서비스는 이동통신사의 월정액 유료부가서비스로, 회사는 본 서비스를 이용자에게 제공하기 위해 다음과 같이 개인정보를 수집/이용합니다.<br/></p>
      <table width="601">
        <tbody>
        <tr>
          <td width="200">
            <p><strong>수집시점</strong></p>
          </td>
          <td width="200">
            <p><strong>개인정보 수집항목</strong></p>
          </td>
          <td width="200">
            <p><strong>수집근거</strong></p>
          </td>
        </tr>
        <tr>
          <td width="200">
            <p>서비스 등록 시 제휴사로부터 수신</p>
          </td>
          <td width="200">
            <p>본인식별값(CI(연계정보), DI(중복확인정보)), 휴대폰번호, 성명, 생년월일, 성별, 내외국인구분, 이메일정보</p>
          </td>
          <td width="200">
            <p>이용자의 동의</p>
          </td>
        </tr>
        <tr>
          <td width="200">
            <p>자동생성정보</p>
          </td>
          <td width="200">
            <p>IP, 쿠키, 방문 일시, 서비스 이용기록, 기기정보, 불량 이용기록 등 서비스 이용 과정에서 자동으로 생성되어 수집되는 정보</p>
          </td>
          <td width="200">
            <p>이용자의 선택</p>
            <p>(거부조치 미적용)</p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>② 회사가 이용자의 개인정보를 수집하는 경우에는 아래의 원칙을 준수하고 있으며, 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구합니다.</p>
      <p>가. 서비스 제공에 필요한 최소한의 개인정보를 수집합니다.</p>
      <p>- 필수정보의 수집: 해당 서비스의 본질적 기능을 수행하기 위한 정보를 필수항목으로 수집합니다.</p>
      <p>- 선택정보의 수집: 이용자에게 특화된 서비스를 제공하기 위해 최소한의 정보를 추가 수집하는 경우, 선택항목으로 수집합니다. 다만, 선택항목을 입력하지 않는 경우에도 다른 서비스 이용 제한은
        없습니다.</p>
      <p>나. 민감정보를 수집하지 않습니다.</p>
      <p>- 회사는 이용자의 소중한 인권을 침해할 우려가 있는 민감한 정보(인종, 사상 및 신조, 정치적 성향이나 범죄기록, 의료정보 등)를 수집하지 않습니다. 단, 법령에서 민감정보의 처리를 요구하거나
        허용하는 경우에는 반드시 이용자에게 해당 사실을 알리고 사전 동의를 구하도록 합니다.</p>
      <p>③ 회사의 개인정보 수집방법은 다음과 같습니다.</p>
      <p>가. 웹서비스, 생성정보 수집 툴을 통한 수집</p>
      <p>④ IP, 쿠키, 방문일시, 서비스 이용기록, 기기정보, 앱ID 정보, 불량 이용 기록 등은 서비스 이용과정에서 자동으로 생성되어 수집되고 있습니다.</p>
      <p>⑤ 회사는 회원가입을 만 14세 이상인 경우에 가능하도록 하며 개인정보의 수집&middot;이용에 법정대리인의 동의가 필요한 만 14세 미만 아동의 개인정보는 원칙적으로 수집하지 않습니다. 단,
        법정대리인의 동의를 얻은 경우에는 만 14세 미만 이용자의 개인정보를 수집&middot;이용할 수 있습니다.</p>
      <p>&nbsp;</p>
      <p><strong>제2조 (개인정보의 이용목적)</strong></p>
      <p>회사는 이용자의 소중한 개인정보를 다음과 같은 목적으로만 이용하며, 목적이 변경될 경우에는 사전에 이용자의 동의를 구하도록 하겠습니다.</p>
      <p><strong>①이용자 식별, 이용의사 확인 및 웹서비스 제공</strong></p>
      <p><strong>②다양한 서비스 제공, 문의사항 또는 불만 처리</strong></p>
      <p><strong>③이용자와 약속한 서비스 제공</strong></p>
      <p><strong>④서비스 이용기록과 접속빈도 분석, 서비스 이용에 대한 통계, 웹서비스 접속 &middot; 이용 유지, 서비스 개선에 활용</strong></p>
      <p>&nbsp;</p>
      <p><strong>제3조 (개인정보의 보유 및 이용기간)</strong></p>
      <p><strong>①&nbsp;이용자의 개인정보는 개인정보의 수집 및 이용목적 달성을 위해 이용기간에만 제한적으로 이용하고 있습니다. 다만, 관계법령에 의해 보관해야 하는 정보는 법령이 정한 기간 동안
        보관합니다.</strong></p>
      <p>&nbsp;</p>
      <p>[관계법령에 따른 개인정보의 보관]</p>
      <p>회사는 관계 법령의 규정에 의하여 보존할 필요가 있는 경우 아래와 같이 관계법령에서 정한 일정한 기간 동안 개인정보를 보관합니다.</p>
      <p>&nbsp;</p>
      <table width="601">
        <tbody>
        <tr>
          <td width="200">
            <p><strong>개인정보</strong></p>
          </td>
          <td width="200">
            <p><strong>보존근거</strong></p>
          </td>
          <td width="200">
            <p><strong>보존기간</strong></p>
          </td>
        </tr>
        <tr>
          <td width="200">
            <p>서비스 이용관련 기록</p>
            <p>(접속IP정보), 접속기기정보</p>
          </td>
          <td width="200">
            <p>통신비밀보호법</p>
          </td>
          <td width="200">
            <p>3개월</p>
          </td>
        </tr>
        <tr>
          <td width="200">
            <p>소비자의 불만 또는</p>
            <p>분쟁처리에 관한 기록</p>
          </td>
          <td width="200">
            <p>전자상거래 등에서의</p>
            <p>소비자보호에 관한 법률</p>
          </td>
          <td width="200">
            <p>3년</p>
          </td>
        </tr>
        <tr>
          <td width="200">
            <p>전자금융 거래에 관한 기록</p>
          </td>
          <td width="200">
            <p>전자금융거래법</p>
          </td>
          <td width="200">
            <p>5년</p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>&nbsp;&nbsp;</p>
      <p><strong>② 서비스 이용 후의 민원처리를 위하여 내부지침에 따라 서비스 이용 후 3년 간 CI(연계정보), DI(중복확인정보), 휴대폰번호, 성명, 생년월일, 내/외국인구분, 성별, 이메일
        정보를 보관합니다.</strong></p>
      <p>&nbsp;</p>
      <p><strong>제4조 (개인정보의 파기)</strong></p>
      <p>이용자의 개인정보는 개인정보의 수집 및 이용목적이 달성되면 해당 정보를 지체 없이 파기합니다. 단, 관계 법령에 의해 개인정보를 보관해야 하는 경우에는 기존 저장 공간과 구분된 별도의 저장공간에
        옮겨서 정해진 기간 동안 저장 후 파기합니다. 이때 별도로 저장되는 개인정보는 법령에 의한 경우가 아니고서는 절대 다른 용도로 이용되지 않습니다. 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수
        없는 기술적 방법을 이용하여 완전히 삭제하고, 종이로 출력된 개인정보는 분쇄하거나 소각하여 파기합니다.</p>
      <p>&nbsp;</p>
      <p><strong>제5조 (개인정보의 위탁)</strong></p>
      <p>회사는 향상된 서비스를 이용자에게 제공하기 위해 다음과 같은 업무를 위탁하고 있습니다.</p>
      <p>[개인정보위탁업체]</p>
      <p>&nbsp;</p>
      <table width="601">
        <tbody>
        <tr>
          <td width="200">
            <p><strong>수탁자</strong></p>
          </td>
          <td width="200">
            <p><strong>위탁업무내용</strong></p>
          </td>
          <td width="200">
            <p><strong>위탁기간</strong></p>
          </td>
        </tr>
        <tr>
          <td width="200">
            <p><strong>주식회사 민앤지</strong></p>
          </td>
          <td width="200">
            <p>SMS,LMS 발송대행</p>
          </td>
          <td width="200">
            <p><strong>위탁 계약 종료시까지</strong></p>
          </td>
        </tr>
        </tbody>
      </table>
      <p><strong>&nbsp;</strong></p>
      <p><strong>제6조 (개인정보의 제공)</strong></p>
      <p>회사는 다양한 서비스를 제공하기 위해 다음과 같이 개인정보를 제3자에게 제공하고 있습니다. 서비스 이용에 필요한 목적을 위해 최소한의 개인정보를 제3자에게 제공하고 있습니다.</p>
      <p>&nbsp;</p>
      <table width="601">
        <tbody>
        <tr>
          <td width="150">
            <p><strong>제공받는 자</strong></p>
          </td>
          <td width="150">
            <p><strong>제공 개인정보 항목</strong></p>
          </td>
          <td width="150">
            <p><strong>이용목적</strong></p>
          </td>
          <td width="150">
            <p><strong>제공기간</strong></p>
          </td>
        </tr>
        <tr>
          <td width="150">
            <p><strong>SK</strong><strong>텔레콤 주식회사</strong></p>
          </td>
          <td width="150">
            <p>휴대폰번호</p>
          </td>
          <td width="150">
            <p><strong>제휴상품 가입/해지, 가입여부확인</strong></p>
          </td>
          <td width="150">
            <p><strong>서비스제공기간(단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 및 사전 동의를 득한 경후 해당 보유 기간)</strong></p>
          </td>
        </tr>
        <tr>
          <td width="150">
            <p><strong>DB</strong><strong>손해보험 주식회사</strong></p>
          </td>
          <td width="150">
            <p>휴대폰번호, 성명, 생년월일, 성별, 내외국인구분, 서비스 가입일/해지일</p>
          </td>
          <td width="150">
            <p><strong>보험가입, 보험료 정산 및 보상처리</strong></p>
          </td>
          <td width="150">
            <p><strong>본 서비스 가입 일부터 해지 후 3년</strong></p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p><strong>&nbsp;</strong></p>
      <p><strong>제7조 (이용자의 권리)</strong></p>
      <p>① 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인 정보를 조회하거나 수정할 수 있으며 등록 해지를 요청할 수도 있습니다.</p>
      <p>② 이용자의 개인정보 조회, 수정, 등록 해지(동의철회)를 위해서는 당사의 고객센터나 홈페이지 등을 통해서 본인확인 절차를 거친 후 직접 열람, 정정 또는 해지가 가능하며, 당사는 영업일 기준 당일
        혹은 다음날까지 처리합니다.</p>
      <p>③ 이용자는 언제든지 당사의 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치합니다.</p>
      <p>④ 이용자가 개인정보의 오류에 대한 정정을 요청한 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를
        제3자에게 지체 없이 통지하여 정정이 이루어지도록 합니다.</p>
      <p><strong>&nbsp;</strong></p>
      <p><strong>제8조 (쿠키의 운용 및 거부)</strong></p>
      <p>① 회사는 개인 맞춤 서비스를 제공하기 위하여 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트 서버가 이용자의 브라우저에게 전송하는 소량의 정보로서 이용자 컴퓨터의 하드디스크에 저장됩니다.
        쿠키는 개인을 식별하는 정보를 자동적/능동적으로 수집하지 않으며, 이용자는 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.</p>
      <p>② 쿠키의 설치/운영 및 거부</p>
      <p>가. 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</p>
      <p>나. 쿠키 설치 허용 여부를 지정하는 방법(Internet Explorer)</p>
      <p>- [도구] 메뉴에서 [인터넷 옵션]을 선택합니다.</p>
      <p>- [개인정보 탭]을 클릭합니다.</p>
      <p>- [고급]을 선택하여 이용자가 원하는 수준으로 설정하시면 됩니다. (Internet Explorer11 버전 기준 예시)</p>
      <p>&nbsp;</p>
      <p><strong>제9조 (개인정보의 안정성 확보)</strong></p>
      <p>회사는 개인정보의 안정성 확보를 위하여 다음과 같은 조치를 취하고 있습니다.</p>
      <p>① 기술적 조치로 개인정보처리시스템의 비밀번호 및 고유식별번호는 암호화되어 관리합니다. 또한 접근권한 관리, 접근 통제 시스템 등을 설치하여 관리합니다.</p>
      <p>② 물리적 조치로 전산실, 자료실 등의 접근을 통제합니다.</p>
      <p>③ 회사는 개인정보의 내부관리계획의 수립 및 시행, 정기적인 직원 교육 등을 실시합니다.</p>
      <p><strong>제10조 (개인정보보호책임자 및 담당부서의 연락처)</strong></p>
      <p>&nbsp;</p>
      <p><strong>[</strong><strong>개인정보보호 책임자]</strong></p>
      <table width="472">
        <tbody>
        <tr>
          <td width="85">
            <p><strong>성 명</strong></p>
          </td>
          <td width="387">
            <p>민홍준</p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>직 책</strong></p>
          </td>
          <td width="387">
            <p>대표이사</p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>연 락 처</strong></p>
          </td>
          <td width="387">
            <p>1688 - 4192</p>
            <p>(평일 09:00 ~ 18:00, 주말/공휴일 휴무)</p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>이 메 일</strong></p>
          </td>
          <td width="387">
            <p><a href="mailto:hj.min@finbridge.co.kr">hj.min@finbridge.co.kr</a></p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>주 소</strong></p>
          </td>
          <td width="387">
            <p>핀브릿지㈜ 서울특별시 마포구 토정로 310, 4층</p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p><strong>[</strong><strong>개인정보보호 담당자]</strong></p>
      <table width="472">
        <tbody>
        <tr>
          <td width="85">
            <p><strong>성 명</strong></p>
          </td>
          <td width="387">
            <p>김강희</p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>직 책</strong></p>
          </td>
          <td width="387">
            <p>VAS사업팀장</p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>연 락 처</strong></p>
          </td>
          <td width="387">
            <p>1688 - 4192</p>
            <p>(평일 09:00 ~ 18:00, 주말/공휴일 휴무)</p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>이 메 일</strong></p>
          </td>
          <td width="387">
            <p><a href="mailto:kanghee.kim@finbridge.co.kr">kanghee.kim@finbridge.co.kr</a></p>
          </td>
        </tr>
        <tr>
          <td width="85">
            <p><strong>주 소</strong></p>
          </td>
          <td width="387">
            <p>핀브릿지㈜ 서울특별시 마포구 토정로 310, 4층</p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>기타 개인정보 침해에 관한 상담이 필요한 경우에는 한국인터넷진흥원 개인정보침해신고센터, 경찰청 사이버테러대응센터 등으로 문의하시기 바랍니다.</p>
      <p>가. 개인정보침해신고센터 : (국번없이)118 (http://privacy.kisa.or.kr)</p>
      <p>나. 대검찰청 사이버수사과 : (국번없이)1301, cid@spo.go.kr (http://spo.go.kr)</p>
      <p>다. 경찰청 사이버안전국 : (국번없이)182 (http://cyberbureau.police.go.kr)</p>
      <p>라. 개인정보 분쟁조정위원회 : 1833-6972 (&nbsp;<a href="http://kopico.go.kr/">http://kopico.go.kr</a>)</p>
      <p>&nbsp;</p>
      <p><strong>제11조(회사의 고지 의무)</strong></p>
      <p>회사는 위 내용에 대한 추가, 삭제, 수정이 있을 경우에는 시행일로부터 최소 7일 전에 공지사항 등을 통해 이용자에게 설명 드립니다. 단, 이용자의 소중한 권리 또는 의무와 관련된 중요한 내용의
        변경은 최소 30일 전에 알려드립니다.</p>
      <p>&nbsp;</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeOfUsageSB"
}
</script>

<style scoped>
.terms-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
}

.terms-title {
  font-size: 20px;
  padding: 10px;
  text-align: center;
}

.terms-container {
  padding: 70px 20px 20px;
}

.terms-container p {
  color: #000;
}

table {
  border-collapse: collapse;
}

td {
  border: 1px solid #000;
  padding: 2px;
  min-width: 60px;
}
</style>